import { Injectable } from '@angular/core';

/**
 * quick-260624-e5c: the `/records` sidenav item now resolves to ONE landing for
 * every role — the new Screen A Collections-by-Org LIST, which is itself
 * role-scoped SERVER-SIDE (GET /api/records/aggregates). The old per-role split
 * (`/records/{school,district,state}`) is retired with the flat records-view
 * landing, so this resolver collapses to a constant `/records`.
 *
 * Kept as a service (rather than inlining the literal at each caller) so the 4
 * callers (app.component + 3 dashboards) keep a single, centrally-changed source
 * of truth for the Records route.
 */
@Injectable({ providedIn: 'root' })
export class RecordsLandingService {
  /** The single Records landing for all roles (Screen A is server-role-scoped). */
  private static readonly RECORDS_ROUTE = '/records';

  /**
   * Resolve the Records landing route. Now role-INDEPENDENT — Screen A scopes
   * server-side, so every role lands on `/records`.
   * @param _roles retained for signature compatibility with the 4 callers.
   * @returns the absolute `/records` route path.
   */
  recordsRouteFor(_roles: readonly string[]): string {
    return RecordsLandingService.RECORDS_ROUTE;
  }
}
